import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './PageForm.scss';

const PageForm = ({children, theme, className, ...props}) => {
  const styleClassNames = classnames({
    'page-form': true,
    [`page-form--${theme}`]: !!theme,
    [className]: !!className,
  });
  return (
    <div className={styleClassNames} {...props}>
      {children}
    </div>
  );
};

PageForm.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['', 'box']),
};

export default PageForm;
